const ALPHABETS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
const ALPHABET_COUNT = 26
export default {
  // アルファベットから数値へ変換
  cellAddress(address) {
    const alphabet = String(address.match(/[A-Z]+/)).split("")
    let index = 0
    let length = alphabet.length - 1
    for (let i = 0; i < alphabet.length; i++) {
      if (i < alphabet.length - 1) {
        index += (ALPHABET_COUNT * this.alphabetToNumber(alphabet[i])) ** length
        length -= 1
      } else {
        index += this.alphabetToNumber(alphabet[i])
      }
    }
    return index
  },
  // アルファベットから数値へ変換（単体）
  alphabetToNumber(alphabet) {
    return ALPHABETS.indexOf(alphabet) + 1
  },
  // 数値からアルファベットの配列へ変換
  getHeaders(count) {
    let array = []
    for (let i = 1; i <= count; i++) {
      let alphabet = ""
      let index = 0
      let number = i
      while (number > 0) {
        let remainder = number % ALPHABET_COUNT
        if (number / ALPHABET_COUNT > 1) {
          number -= remainder
          number = number / ALPHABET_COUNT
        } else {
          number = 0
        }
        index = remainder == 0 ? ALPHABET_COUNT - 1 : remainder - 1
        alphabet = ALPHABETS[index] + alphabet
      }
      array.push(alphabet)
    }
    return  array
  },
  // エクセルの高さ(dpi)をPixelに変換
  dpiToPixel(number) {
    return (number / 72) * 96
  },
  // この形[A1:B2]の結合セル情報を連想配列に変換
  mergedCellInfo(data){
    const cells = data.split(":")
    const left = this.cellAddress(cells[0])
    const right = this.cellAddress(cells[1])
    const top = cells[0].match(/[0-9]+$/)[0]
    const bottom = cells[1].match(/[0-9]+$/)[0]
    return {left, right, top, bottom}
  }
}
